import { Fragment, useState,useEffect,useMemo } from "react";
import Header from "../common/Header";
import { useParams,useNavigate } from "react-router-dom";
import Footer from "../common/Footer";
import { useLocation } from "react-router-dom";
import PaymentSuccess from './PaymentSuccess';
import PaymentFailed from './PaymentFailed';
import axios from "axios";

const Payment = () => {
    let { type } = useParams();
    const navigate = useNavigate();
    const { search } = useLocation();
    const [countdown, setCountdown] = useState(30);
    const params = useMemo(() => {
        return new URLSearchParams(search);
    }, [search]);

    const status = params.get("status");  
    const qrCode = params.get("payment_id");  
    const isSuccess = Number(status) === 1;
    const [cartData, setCartData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!qrCode || !isSuccess) {
            return;
        }

        const MAX_RETRIES = 10;
        const RETRY_DELAY = 1000;
        let isMounted = true;
        let retryTimeout = null;

        const fetchCart = async (retry = 0) => {
            try {
                if (retry === 0) {
                    setLoading(true);
                    setError(null);
                }

                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_ENDPOINT}qr-web/get-cart/${qrCode}`,
                    {
                        headers: {
                            Authorization: `Bearer ${process.env.REACT_APP_PARCEL_POINT_API_KEY}`,
                            Accept: "application/json"
                        }
                    }
                );
                
                const data = response?.data;
                const hasValidData = data && (Array.isArray(data) ? data.length > 0 : typeof data === "object" ? Object.keys(data).length > 0 : true);

                if (!hasValidData) {
                    if (retry < MAX_RETRIES) {
                        retryTimeout = setTimeout(() => {
                            if (isMounted) {
                                fetchCart(retry + 1);
                            }
                        }, RETRY_DELAY);
                        return;
                    }
                    throw new Error("Cart data not available yet.");
                }

                localStorage.removeItem("shipment_details");
                localStorage.removeItem("cart_id");

                if (isMounted) {
                    setCartData(response.data);
                    setLoading(false);
                }

            } catch (err) {
                if (!isMounted) {
                    return;
                }

                console.error("Cart fetch error:", err);

                if (retry < MAX_RETRIES) {
                    retryTimeout = setTimeout(() => {
                        if (isMounted) {
                            fetchCart(retry + 1);
                        }
                    }, RETRY_DELAY);

                    return;
                }
                
                setError(err?.response?.data?.message || err?.message || "Failed to fetch cart.");
                setLoading(false);
            }
        };

        fetchCart();

        return () => {
            isMounted = false;

            if (retryTimeout) {
                clearTimeout(retryTimeout);
            }
        };

    }, [qrCode,isSuccess]);

    useEffect(() => {
        if (loading) {
            return;
        }

        if (isSuccess || cartData ) {
            const interval = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        navigate("/pp");
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(interval);
        }

    }, [loading, isSuccess, cartData, error, navigate]);

    return <Fragment>
        <Header type={type} />
        {!isSuccess && <PaymentFailed />}
        {isSuccess && (
                <>
                    {loading && (
                        <div className="flex items-center justify-center min-h-[300px]">
                            <div className="text-center">
                                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
                                <p className="mt-4">Loading your shipment and payment details.</p>
                            </div>
                        </div>
                    )}

                    {error && !loading && (
                        <div className="text-center text-red-500">
                            {error}
                        </div>
                    )}

                    {!loading && !error && cartData && (
                        <PaymentSuccess
                            payment_method="Card"
                            amount={params.get("amount")}
                            transaction_id={params.get("transaction_id")}
                            payment_id={params.get("payment_id")}
                            msg={params.get("msg")}
                            cartData={cartData}
                            countdown={countdown}
                        />
                    )}
                </>
            )}
        <Footer/>
    </Fragment>
}

export default Payment;